<!-- We'll want our page wrapped in the app-page component which handles errors. -->
<app-page [(error)]="error">

  <!-- Define our page card. -->
  <mat-card class="mat-page-card">

    <!-- Define the header of our page card. -->
    <mat-card-header>

      <!-- Give our page an icon. -->
      <mat-icon mat-card-avatar color="icon-orange">dashboard</mat-icon>

      <!-- Give our page a main title. -->
      <mat-card-title>
        Employee Document Dashboard
      </mat-card-title>

      <!-- Give our page a very short description. -->
      <mat-card-subtitle>Select a Tax Year to view or download your year-end documents.</mat-card-subtitle>
    </mat-card-header>

    <!-- Define the content of our page card. -->
    <mat-card-content>

      <div>

        <!-- Define a form field for selecting a year. -->
        <mat-form-field *ngIf="!hideYearSelect">

          <!-- Define a label for the select. -->
          <mat-label>Tax Year</mat-label>

          <!-- Define a select for choosing a year. -->
          <mat-select (selectionChange)="onYearSelectChange($event)">

            <!-- Loop through the years and create an option for each. -->
            @for (year of years; track $index) {
              <mat-option value="{{ year }}">{{ year }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div>
        <table *ngIf="!hideDocuments" mat-table [dataSource]="documents" class="mat-elevation-z8">

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element; let i = index;"><a
              (click)="loadDocument(element)"
              aria-label="Link to view the PDF in the current browser window or tab."
              color="primary"
              mat-button matTooltip="View PDF."
              matTooltipPosition="below">{{ element.name }}</a></td>
          </ng-container>

          <!-- Modified Column -->
          <ng-container matColumnDef="modified">
            <th mat-header-cell *matHeaderCellDef>Modified</th>
            <td mat-cell *matCellDef="let element">{{ element.modified | date: 'medium' }}</td>
          </ng-container>

          <!-- Series Column -->
          <ng-container matColumnDef="series">
            <th mat-header-cell *matHeaderCellDef>Series</th>
            <td mat-cell *matCellDef="let element;"> {{ element.series }}</td>
          </ng-container>

          <!-- Size Column -->
          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef>Size</th>
            <td mat-cell *matCellDef="let element;">{{ element.size | byteSize }}</td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="_actions">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let element; let i = index;">

              <!-- Download Button -->
              <a mat-button color="secondary"
                (click)="downloadDocument(element)"
                aria-label="Link that downloads the PDF."
                matTooltip="Download PDF."
                matTooltipPosition="below">
                <mat-icon>download</mat-icon>
                Download
              </a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" *ngIf="!documents.length && currentYear !== 0" colspan="5" style="text-align: center;">
              No Documents Found for Tax Year {{ currentYear }}.
            </td>
            <td class="mat-cell" *ngIf="loading" colspan="5">
              <span style="display: flex; justify-content: center; align-items: center; width: 100%;">
                <mat-spinner color="warn" diameter="20"></mat-spinner>
                &nbsp;
                Loading
              </span>
            </td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</app-page>
